import React from "react";
import ReactDOM from "react-dom/client";
import AppRouter from "./approuter";
import "react-datepicker/dist/react-datepicker.css";

// FontAwesome
import "./assets/icons/fontawesome/css/all.css";
import "./assets/icons/fontawesome/css/all.min.css";
import "./assets/icons/fontawesome/css/fontawesome.min.css";

// Icons
import "./assets/icons/feather/feather.css";
import "./assets/js/feather.min.js";

// React custom stylesheet
import "../src/index.css";

// Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "./queryClient.js"; // Ensure this file exists

// Style
import "./assets/css/style.css";
import axios from "../src/api/axios"; // Ensure this file exists

import { jQuery } from "jquery";
import { user_type, Apitoken, Authtoken } from "../src/Global"; // Ensure this file exists

window.$ = jQuery;
window.jQuery = jQuery;

var isLoggedInVar = null;

// Check if Auth Token is valid
if(user_type !='customer'){
  axios
  .get(`/auth-token-valid-or-not`, {
    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  })
  .then((response) => {
    if (response.data.code === 200) {
      
   
            let season_id = response.data.data.season.id;
            let season_name = response.data.data.season.name;
            let season_start = response.data.data.season.start;
            let season_end = response.data.data.season.end;
            
             localStorage.setItem("all_seasons", JSON.stringify(response.data.data.seasons));
           
            localStorage.setItem("season_id", season_id);
            localStorage.setItem("season_name", season_name);
            localStorage.setItem("season_start", season_start);
            localStorage.setItem("season_end", season_end);

      isLoggedInVar = true;
      fetchData();
    } else {
      redirectLoginPage();
      isLoggedInVar = null;
    }
  })
  .catch((error) => {
    console.log(error);
  });
}

 

// Function to handle login redirects
const fetchData = () => {
  let url = window.location.href.split("/");
  
  if (isLoggedInVar != null && url[3] === "") {
    window.location.href = "/profile";
  } else if (isLoggedInVar == null && (url[3] === "" || url[3] === "profile")) {
    clearAuthData();
    window.location.href = "/login";
  } else if (isLoggedInVar != null && url[3] === "login") {
    window.location.href = "/profile";
  }
};

// Function to clear authentication data
const clearAuthData = () => {
  localStorage.removeItem("isLoggedIn");
  localStorage.removeItem("auth_token");
  localStorage.removeItem("auth_id");
  localStorage.removeItem("auth_name");
  localStorage.removeItem("auth_email");
  localStorage.removeItem("auth_role");
  localStorage.removeItem("firebase_token");
  localStorage.removeItem("profile_image");
  localStorage.removeItem("menu_modules");
};

// Function to redirect to login page
const redirectLoginPage = () => {
  let url = window.location.href.split("/");
  if (isLoggedInVar == null && url[3] === "") {
    clearAuthData();
    window.location.href = "/login";
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <AppRouter />
  </QueryClientProvider>
);
